"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var importIcons = require.context("../../../assets/feature-icons", false, /\.(svg|png|jpg|jpeg|gif)$/);

// Map of icon names to paths
var iconMap = importIcons.keys().reduce(function (map, filePath) {
  var name = filePath.replace("./", "").replace(/\.[^/.]+$/, "");
  map[name] = importIcons(filePath);
  return map;
}, {});
var FeatureIcon = function FeatureIcon(_ref) {
  var icon = _ref.icon,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var iconPath = iconMap[icon];
  if (!iconPath) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      src: iconMap["water-access"]["default"],
      style: style
    });
  }
  return /*#__PURE__*/_react["default"].createElement("img", {
    src: iconPath["default"],
    style: style
  });
};
var _default = exports["default"] = FeatureIcon;